import * as React from "react";

interface IExtLinkProps {
    to: string,
    className?: string,
    children?: React.ReactNode,
}

const ExtLink = (props: IExtLinkProps) => (
    <a href={props.to} target="_blank" rel="noopener noreferrer" className={props.className}>{React.Children.count(props.children) ? props.children : props.to}</a>
);

export default ExtLink;
